import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m213.333 295.986 30.167 30.166-100.417 100.515L42.667 326.152l30.166-30.166 48.917 48.916V106.667h42.667v238.235l48.916-48.916ZM356.417 85.333 255.999 185.856l30.166 30.166 48.918-48.918v238.23h42.667V167.106l48.915 48.915 30.167-30.166L356.417 85.333Z",
      fill: "#000",
      "fill-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render };